function mainNav() {

    /**
     * File navigation.js.
     *
     * Handles toggling the navigation menu for small screens and enables TAB key
     * navigation support for dropdown menus.
     */

    const siteHeader = document.querySelector('.site-header');

    const container = document.getElementById('site-navigation');
    if (!container) {
        return;
    }

    const mainMenu = document.getElementById('menu-main-menu');

    if ('undefined' === typeof mainMenu) {
        return;
    }

    // toggle click on menu items with class .headerMenu__itemLink, and add class .open
    const menuItems = document.querySelectorAll('button.headerMenu__itemLink');
    menuItems.forEach((item) => {

        // add aria-hidden="true" to each .sub-menu div that is a sibling of item
        const subMenu = item.parentNode.querySelector('.sub-menu');
        if (subMenu) {

            // give unique id to each .subMenu div that is a sibling of item
            const subMenuId = 'subMenu-' + item.parentNode.id;
            subMenu.setAttribute('id', subMenuId);

            // add aria attributes to each item
            item.setAttribute('aria-expanded', 'false');
            item.setAttribute('aria-haspopup', 'true');
            item.setAttribute('aria-controls', subMenuId);

            subMenu.setAttribute('aria-hidden', 'true');

            // find all links in the subMenu and add tabindex="-1"
            const subMenuLinks = subMenu.querySelectorAll('a');
            subMenuLinks.forEach((link) => {
                link.setAttribute('tabindex', '-1');
            });
        }

        item.addEventListener('click', (event) => {

            const clickedItem = event.currentTarget;

            menuItems.forEach((otherItem) => {
                if (otherItem !== clickedItem) {
                    otherItem.parentNode.classList.remove('open');
                    otherItem.setAttribute('aria-expanded', 'false');

                    const otherMegaMenuWrapper = otherItem.parentNode.querySelector('.sub-menu');

                    if (otherMegaMenuWrapper) {
                        otherMegaMenuWrapper.setAttribute('aria-hidden', 'true');
                        otherMegaMenuWrapper.querySelectorAll('a').forEach((link) => {
                            link.setAttribute('tabindex', '-1');
                        });
                    }
                }
            });

            siteHeader.classList.toggle('menu-open');
            clickedItem.parentNode.classList.toggle('open');

            // toggle aria-hidden="true" on each .sub-menu div that is a sibling of clickedItem

            if (subMenu) {

                if (clickedItem.parentNode.classList.contains('open')) {
                    subMenu.setAttribute('aria-hidden', 'false');
                    clickedItem.setAttribute('aria-expanded', 'true');

                    // focus on first link in mega menu
                    const firstLink = subMenu.querySelector('a');
                    if (firstLink) {
                        firstLink.focus();
                    }

                    subMenu.querySelectorAll('a').forEach((link) => {
                        link.setAttribute('tabindex', '0');
                    });
                } else {
                    subMenu.setAttribute('aria-hidden', 'true');
                    clickedItem.setAttribute('aria-expanded', 'false');
                    subMenu.querySelectorAll('a').forEach((link) => {
                        link.setAttribute('tabindex', '-1');
                    });

                }
            }

        });
    });

    // click anywhere outside of menu to close menu
    document.addEventListener('click', (event) => {
        const target = event.target;
        const isClickInside = container.contains(target);
        if (!isClickInside) {
            siteHeader.classList.remove('menu-open');
            menuItems.forEach((item) => {
                item.parentNode.classList.remove('open');

                // add aria-hidden="true" to each .sub-menu div that is a sibling of item
                const subMenu = item.parentNode.querySelector('.sub-menu');
                if (subMenu) {
                    subMenu.setAttribute('aria-hidden', 'true');
                    item.setAttribute('aria-expanded', 'false');
                    subMenu.querySelectorAll('a').forEach((link) => {
                        link.setAttribute('tabindex', '-1');
                    });
                }
            });
        }
    });

    // press escape key to close menu
    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            siteHeader.classList.remove('menu-open');
            menuItems.forEach((item) => {
                item.parentNode.classList.remove('open');

                // add aria-hidden="true" to each .sub-menu div that is a sibling of item
                const subMenu = item.parentNode.querySelector('.sub-menu');
                if (subMenu) {
                    subMenu.setAttribute('aria-hidden', 'true');
                    item.setAttribute('aria-expanded', 'false');
                    subMenu.querySelectorAll('a').forEach((link) => {
                        link.setAttribute('tabindex', '-1');
                    });
                }
            });
        }
    });

};

const init = () => {
    mainNav();
};

export default init;
